import * as React from 'react';

import { PromoItem } from './PromoItem';
import { PromoModal } from './PromoModal/PromoModal';
import { EType } from '../../../types/villagePromotions';

interface IPromoProps {
  description?: string | null;
  endDate: string;
  name: string;
  type: EType;
  villageId: number;
  villageName?: string | null;
  villageLogoUrl?: string | null;
  phoneButton?: React.ReactNode;
  labelPromoLogoUrl?: string;
  promoLogoUrl?: string;
  subtitle?: string;
}

export function Promo({
  type,
  name,
  endDate,
  description,
  villageLogoUrl,
  villageName,
  phoneButton,
  promoLogoUrl,
  subtitle,
}: IPromoProps) {
  const [isDescriptionModalOpen, setDescriptionModalOpen] = React.useState(false);

  return (
    <>
      <PromoItem
        promoType={type}
        title={name}
        icon={promoLogoUrl}
        subtitle={subtitle}
        onClick={() => setDescriptionModalOpen(!isDescriptionModalOpen)}
      />
      <PromoModal
        open={isDescriptionModalOpen}
        closeModal={() => setDescriptionModalOpen(!isDescriptionModalOpen)}
        name={name}
        endDate={subtitle || endDate}
        description={description}
        villageLogoUrl={villageLogoUrl}
        villageName={villageName}
        phoneButton={phoneButton}
      />
    </>
  );
}
